<template>
    <div class="tw-px-8 tw-py-2">
        <Table
            :columns="columns"
            :data="accounts"
            size="small"
            :no-data-text="$t('bankProfile.noAccounts')"
        >
            <template slot-scope="{ row: account }" slot="employee">
                <span v-if="account.employee">
                    {{ account.employee.employee_name_en || account.employee.employee_name_kh }}
                </span>
                <span v-else class="tw-text-gray-300">—</span>
            </template>
            <template slot-scope="{ row: account }" slot="qr_image">
                <img
                    v-if="account.qr_image"
                    :src="account.qr_image"
                    class="tw-w-8 tw-h-8 tw-object-cover tw-rounded tw-border tw-border-gray-200 tw-mx-auto"
                />
                <span v-else class="tw-text-gray-300">—</span>
            </template>
            <template slot-scope="{ row: account }" slot="action">
                <a
                    href="#"
                    class="text-primary"
                    @click.prevent="onEdit(account)"
                    v-tooltip="$t('edit')"
                >
                    <Icon type="ios-create" size="20" />
                </a>
                <Poptip
                    :title="$t('are_you_sure_to_delete')"
                    :transfer="true"
                    width="200"
                >
                    <a
                        class="ml-2 text-danger"
                        v-tooltip="$t('delete')"
                        :disabled="account._deleting"
                    >
                        <i class="fas fa-circle-notch fa-spin" v-if="account._deleting"></i>
                        <Icon type="ios-trash" size="20" v-else />
                    </a>
                    <div slot="content" class="tw-text-right tw-mt-2">
                        <a
                            class="ivu-btn ivu-btn-danger ivu-btn-small"
                            @click.prevent="onDelete(account)"
                        >
                            <span>{{ $t("yes") }}</span>
                        </a>
                    </div>
                </Poptip>
            </template>
        </Table>

        <account-form-modal
            v-if="row && row.bank_id"
            v-model="accountModal"
            :bank-id="row.bank_id"
            :bank-name="row.bank_name"
            :account="editingAccount"
            @saved="onAccountSaved"
        />
    </div>
</template>

<script>
import AccountFormModal from "./components/account-form-modal.vue";

export default {
    name: "BankProfileTableExpand",
    components: { AccountFormModal },
    props: {
        row: { type: Object, required: true }
    },
    data() {
        return {
            accounts: this.row.accounts ? [...this.row.accounts] : [],
            accountModal: false,
            editingAccount: null
        };
    },
    computed: {
        columns() {
            return [
                {
                    title: this.$t("bankProfile.employeeId"),
                    slot: "employee",
                    minWidth: 180
                },
                {
                    title: this.$t("bankProfile.accountNo"),
                    key: "account_no",
                    minWidth: 160
                },
                {
                    title: this.$t("bankProfile.accountName"),
                    key: "account_name",
                    minWidth: 200
                },
                {
                    title: this.$t("bankProfile.qrImage"),
                    slot: "qr_image",
                    width: 80,
                    align: "center"
                },
                {
                    title: this.$t("bankProfile.isReceiveCashTransfer"),
                    key: "is_receive_cash_transfer",
                    width: 140,
                    align: "center",
                    render: (h, { row }) =>
                        h("i-switch", {
                            props: {
                                value: row.is_receive_cash_transfer,
                                size: "small",
                                disabled: true
                            }
                        })
                },
                {
                    title: this.$t("actions"),
                    slot: "action",
                    align: "center",
                    width: 100
                }
            ];
        }
    },
    methods: {
        async reloadAccounts() {
            const data = await this.$store.dispatch(
                "finance/bankProfile/listAccounts",
                { bankId: this.row.bank_id, params: {} }
            );
            this.accounts = data || [];
            this.row.accounts = this.accounts;
        },
        onEdit(account) {
            this.editingAccount = account;
            this.accountModal = true;
        },
        onDelete(account) {
            this.$set(account, "_deleting", true);
            this.$store
                .dispatch("finance/bankProfile/destroyAccount", account.account_id)
                .then(response => {
                    this.notice({
                        type: response && response.message_id == 0 ? "success" : "warning",
                        text: (response && response.message) || this.$t("deleted")
                    });
                    this.reloadAccounts();
                })
                .catch(error =>
                    this.notice({ type: "error", text: error.message })
                )
                .finally(() => this.$set(account, "_deleting", false));
        },
        onAccountSaved({ response, isEdit }) {
            this.notice({
                type: response && response.message_id == 0 ? "success" : "warning",
                text:
                    (response && response.message) ||
                    (isEdit ? this.$t("updated") : this.$t("saved"))
            });
            this.reloadAccounts();
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "BANK PROFILE",
                desc: not.text
            });
        }
    }
};
</script>
